



















import moment from 'moment-timezone'
import ThreeDotMenu from '@/components/sub-components/ThreeDotMenu.vue'
import ConfirmDeleteActionDialog from '@/components/dialog/ConfirmDeleteActionDialog.vue'

export default {
  components: {
    ThreeDotMenu,
    ConfirmDeleteActionDialog,
  },
  props: {
    patientExercise: {
      type: Object,
      required: true,
    },
    isGeneratingPdf: {
      type: Boolean,
      default: false,
    },
    patientName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDeletePatientExerciseDialog: false,
    }
  },
  computed: {
    tableOptions() {
      return [
        {
          label: 'Export to PDF',
          icon: 'mdi-file-pdf-box',
          color: 'black',
          action: this.exportRecordToPdf,
        },
        {
          label: 'Export to CSV',
          icon: 'mdi-google-spreadsheet',
          color: 'black',
          action: this.exportRecordToCsv,
        },
        {
          label: 'Delete',
          icon: 'mdi-trash-can-outline',
          color: 'red',
          action: this.openDeleteRecordDialog,
        },
      ]
    },
    formattedExerciseDate() {
      return moment(this.patientExercise.exerciseDate).format('Do MMMM YYYY')
    },
    patientExerciseHeader() {
      if (this.isGeneratingPdf) {
        return `${this.patientName} - ${this.formattedExerciseDate}`
      }
      return this.formattedExerciseDate
    },
  },
  methods: {
    exportRecordToCsv() {
      this.$emit('exportPatientExerciseToCsvAction', this.patientExercise.id)
    },
    exportRecordToPdf() {
      this.$emit('exportPatientExerciseToPdfAction', this.patientExercise.id)
    },
    closeDeleteRecordDialog() {
      this.showDeletePatientExerciseDialog = false
    },
    openDeleteRecordDialog() {
      this.showDeletePatientExerciseDialog = true
    },
    confirmDeleteRecord() {
      this.showDeletePatientExerciseDialog = false
      this.$emit('deletePatientExerciseAction', this.patientExercise.id)
    },
  },
}
